import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './slices/authSlice';
import { baseApi, baseApiMiddleware, baseApiReducer, baseApiReducerPath } from './services/baseApi';
import { authApi } from './services/auth';
import { usersApi } from './services/users';
import { shopsApi } from './services/shops';
import { shopCategoriesApi } from './services/shopCategories';
import { productCategoriesApi } from './services/productCategories';
import { productsApi } from './services/products';
import { companiesApi } from './services/companies';
import { shopProductsApi } from './services/shopProducts';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [baseApiReducerPath]: baseApiReducer,
    [authApi.reducerPath]: authApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [shopsApi.reducerPath]: shopsApi.reducer,
    [shopCategoriesApi.reducerPath]: shopCategoriesApi.reducer,
    [productCategoriesApi.reducerPath]: productCategoriesApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [companiesApi.reducerPath]: companiesApi.reducer,
    [shopProductsApi.reducerPath]: shopProductsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(baseApiMiddleware)
      .concat(authApi.middleware)
      .concat(usersApi.middleware)
      .concat(shopsApi.middleware)
      .concat(shopCategoriesApi.middleware)
      .concat(productCategoriesApi.middleware)
      .concat(productsApi.middleware)
      .concat(companiesApi.middleware)
      .concat(shopProductsApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;